import React from 'react';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';
import ReactGA from 'react-ga';

// Auth
import AuthContainer from './containers/AuthContainer';

// Home
import HomeContainer from './containers/HomeContainer';

const onRouteUpdate = () => {
  ReactGA.pageview(window.location.hash);
  console.log('Route change', window.location.hash);
};

export default function Routes() {
  return (
    <Router onUpdate={onRouteUpdate}>
      <Switch>
        <Route path="/app" component={HomeContainer} />
        <Route path="/" component={AuthContainer} />
      </Switch>
    </Router>
  );
}
